import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { useConfig } from "wagmi";
import { reconnect } from "wagmi/actions";
import { useConnectors } from "../../hooks/useConnectors";
export function useWithConnectorErrorRetry() {
  const $ = _c(3);
  const config = useConfig();
  const {
    activeConnector
  } = useConnectors();
  let t0;
  if ($[0] !== activeConnector || $[1] !== config) {
    t0 = async fn => {
      ;
      try {
        return await fn();
      } catch (t1) {
        const error = t1;
        if (error instanceof Error && (error.message.includes("Connector not connected") || error.message.includes("connector.getChainId is not a function"))) {
          const connectors = activeConnector && activeConnector.chainArch === "EVM" ? [activeConnector.baseConnector] : [];
          await reconnect(config, {
            connectors
          });
          return await fn();
        }
        throw error;
      }
    };
    $[0] = activeConnector;
    $[1] = config;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}